import type { PaginationStateProps } from 'components/shared/Blotter/Pagination/Pagination.model';
import { connect } from 'react-redux';
import { fromSecondaryOrderBlotter } from 'state/selectors';
import type { AppState } from 'state/state.model';

export const mapStateToProps = (state: AppState): PaginationStateProps => {
  const totalItems = fromSecondaryOrderBlotter.getDisplayedItemsCnt(state);
  return {
    totalItems,
    showOnlySummary: true,
  };
};

export const connectSecondaryMarketOrderBlotterPagination = connect(mapStateToProps);
